var fe = Object.defineProperty;
var ge = (n, t, e) => t in n ? fe(n, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[t] = e;
var G = (n, t, e) => ge(n, typeof t != "symbol" ? t + "" : t, e);
import { jsx as i, jsxs as g, Fragment as O } from "react/jsx-runtime";
import { Flex as S, Box as x, Tooltip as M, Text as h, Stack as R, IconButton as pe, Kbd as he } from "@chakra-ui/react";
import { MarkNode as Ee } from "@lexical/mark";
import { LexicalComposer as xe } from "@lexical/react/LexicalComposer";
import { LexicalErrorBoundary as ye } from "@lexical/react/LexicalErrorBoundary";
import { HistoryPlugin as be } from "@lexical/react/LexicalHistoryPlugin";
import { OnChangePlugin as Ce } from "@lexical/react/LexicalOnChangePlugin";
import { RichTextPlugin as Te } from "@lexical/react/LexicalRichTextPlugin";
import { $isElementNode as Ne, createCommand as p, ElementNode as Se, isHTMLElement as _e, $createParagraphNode as z, COMMAND_PRIORITY_LOW as H, $getSelection as ee, $isRangeSelection as te, TextNode as Re, $applyNodeReplacement as Ie, SELECTION_CHANGE_COMMAND as Oe, COMMAND_PRIORITY_CRITICAL as Le, $isLineBreakNode as Me, $getRoot as ne, $createTextNode as Pe } from "lexical";
import we, { useImperativeHandle as De, useEffect as y, createContext as Ae, useContext as ke, useState as P, useCallback as F, useMemo as ve, forwardRef as Fe, useRef as Be } from "react";
import { chakra as $e } from "@chakra-ui/system";
import { ContentEditable as Ue } from "@lexical/react/LexicalContentEditable";
import { useLexicalComposerContext as b } from "@lexical/react/LexicalComposerContext";
import { $setBlocksType as Xe, $isAtNodeEnd as V } from "@lexical/selection";
import { addClassNamesToElement as re, mergeRegister as D, $findMatchingParent as K } from "@lexical/utils";
import { LexicalTypeaheadMenuPlugin as je } from "@lexical/react/LexicalTypeaheadMenuPlugin";
import * as ze from "react-dom";
import { createPortal as He } from "react-dom";
import { Icon as _, ConnectorIcon as Je, getResourceIconName as We, SimpleReference as Ge } from "@pufflig/prompt-studio-ui";
import { useLexicalTextEntity as Ve } from "@lexical/react/useLexicalTextEntity";
import "uuid";
import { TreeView as Ke } from "@lexical/react/LexicalTreeView";
const Ye = $e(Ue);
function qe({ onRef: n }) {
  return /* @__PURE__ */ i("div", { ref: n, className: "content_editable-container", children: /* @__PURE__ */ i(
    Ye,
    {
      "data-enable-grammarly": "false",
      cursor: "text",
      textStyle: "paragraph/M/regular",
      position: "relative",
      flex: "1",
      outline: "none",
      paddingY: "2",
      background: "background.primary"
    }
  ) });
}
const Qe = (n) => {
  let t = "";
  const e = n.getChildren(), o = e.length;
  for (let c = 0; c < o; c++) {
    const l = e[c];
    t += l.getTextContent(), Ne(l) && c !== o - 1 && !l.isInline() && (t += `
`);
  }
  return t;
}, oe = (n) => {
  try {
    const t = JSON.parse(n), e = (o) => {
      var l;
      let c = "";
      if (o.type === "comment")
        return c;
      if (typeof o.text == "string" && (c += o.text), Array.isArray(o.children)) {
        const d = o.children, s = d.length;
        for (let a = 0; a < s; a++) {
          const u = d[a];
          if (u.type === "comment") {
            a !== s - 1 && (c += `
`);
            continue;
          }
          c += e(u), u.type === "paragraph" && ((l = u.children) != null && l.length) && (c += `
`);
        }
      }
      return c;
    };
    return e(t.root);
  } catch {
    return "";
  }
};
function Ze({
  editorRef: n,
  previousTextRef: t
}) {
  const [e] = b();
  return De(
    n,
    () => ({
      setEditorValue: (o) => {
        const c = e.parseEditorState(o);
        e.setEditorState(c), t.current = oe(o), e.focus(void 0, { defaultSelection: "rootEnd" });
      }
    }),
    [e]
  ), null;
}
const et = "UPLOAD_FILE", tt = "OPEN_CONTEXT", nt = "RUN_PROMPT", rt = "UPDATE_FORMAT", ot = "UPDATE_BEHAVIOR", ct = "INSERT_PROMPT", it = "RENAME_PROMPT", st = "DUPLICATE_PROMPT", at = "DELETE_PROMPT", lt = "DELETE_REFERENCES", dt = "RENAME_REFERENCES", ut = "INSERT_REFERENCE", mt = "INSERT_BLOCK";
p(et);
p(tt);
p(nt);
p(rt);
p(ot);
p(ct);
p(it);
p(st);
p(at);
p(lt);
p(dt);
const ce = p(ut), ie = p(mt), ft = "INSERT_NEW_FILE_PLACEHOLDER", gt = "INSERT_NEW_TEXT_PLACEHOLDER", pt = "INSERT_PLACEHOLDER_REFERENCE";
p(ft);
p(gt);
p(pt);
function ht(n) {
  const t = B();
  return n.style !== null && t.setFormat(n.style.textAlign), { node: t };
}
class A extends Se {
  static getType() {
    return "comment";
  }
  static clone(t) {
    return new A(t.__key);
  }
  constructor(t) {
    super(t);
  }
  createDOM(t) {
    const e = document.createElement("blockquote");
    return re(e, t.theme.comment), e;
  }
  updateDOM() {
    return !1;
  }
  static importDOM() {
    return {
      blockquote: () => ({
        conversion: ht,
        priority: 0
      })
    };
  }
  exportDOM(t) {
    const { element: e } = super.exportDOM(t);
    if (e && _e(e)) {
      this.isEmpty() && e.append(document.createElement("br"));
      const o = this.getFormatType();
      e.style.textAlign = o;
      const c = this.getDirection();
      c && (e.dir = c);
    }
    return {
      element: e
    };
  }
  static importJSON(t) {
    const e = B();
    return e.setFormat(t.format), e.setIndent(t.indent), e.setDirection(t.direction), e;
  }
  exportJSON() {
    return {
      ...super.exportJSON(),
      type: "comment"
    };
  }
  getTextContent() {
    return `{{! ${super.getTextContent().replace(/([{}])/g, "\\$1")} }}`;
  }
  // mutation
  insertNewAfter(t, e) {
    const o = z(), c = this.getDirection();
    return o.setDirection(c), this.insertAfter(o, e), o;
  }
  collapseAtStart() {
    const t = z();
    return this.getChildren().forEach((o) => t.append(o)), this.replace(t), !0;
  }
}
function B() {
  return new A();
}
const Et = (n, t) => {
  const e = ee(), o = B();
  if (t) {
    const c = t.getParent();
    c == null || c.replace(o, !0), t.remove(), o.selectEnd();
    return;
  }
  te(e) && Xe(e, B);
};
function xt() {
  const [n] = b();
  return y(() => D(
    n.registerCommand(
      ie,
      (t) => {
        const { optionId: e, nodeToReplace: o } = t;
        return Et(e, o), !1;
      },
      H
    )
  ), [n]), null;
}
const yt = () => {
  const [n] = b();
  y(() => D(
    n.registerNodeTransform(A, (t) => {
      const o = t.getChildren().filter((c) => c.getType() === "comment");
      o.length > 0 && n.update(() => {
        o.forEach((c) => {
          c.replace(z(), !0);
        });
      });
    })
  ), [n]);
};
function bt() {
  return yt(), xt(), null;
}
const Ct = "UPLOAD_FILE", se = p(Ct), Tt = [
  {
    id: "file_upload",
    name: "Upload a File",
    group: "external_data",
    description: "Upload a file into your prompt"
  },
  {
    id: "comment",
    name: "Comment",
    group: "block",
    description: "Comments cannot be seen by the LLM"
  }
], Y = [
  "external_data",
  "block",
  "table",
  "connector",
  "text",
  "secret",
  "json"
], Nt = (n) => n.sort((o, c) => Y.indexOf(o.group) - Y.indexOf(c.group)).map((o, c) => ({ ...o, index: c })).reduce((o, c) => ({
  ...o,
  [c.group]: [...o[c.group] || [], c]
}), {});
function L(n) {
  const {
    id: t,
    isSelected: e,
    onClick: o,
    onMouseEnter: c,
    setRefElement: l,
    secondaryLabel: d,
    primaryLabel: s,
    tabIndex: a = -1,
    leftIcon: u,
    rightIcon: f
  } = n;
  return /* @__PURE__ */ i(
    S,
    {
      direction: "column",
      cursor: "pointer",
      gap: "0.5",
      padding: "spacing-xxs",
      paddingX: "spacing-sm",
      bg: e ? "background.secondary" : "transparent",
      tabIndex: a,
      ref: l,
      role: "option",
      "aria-selected": e,
      id: t,
      onMouseEnter: c,
      onClick: o,
      children: /* @__PURE__ */ g(S, { justifyContent: "space-between", flex: "1", children: [
        /* @__PURE__ */ g(S, { alignItems: "left", gap: "1", flexDirection: "row", flex: "1", children: [
          /* @__PURE__ */ i(x, { children: u }),
          /* @__PURE__ */ g(S, { flexDirection: "column", children: [
            /* @__PURE__ */ i(M, { label: s, "aria-label": s, children: /* @__PURE__ */ i(h, { mt: "1px", noOfLines: 1, textOverflow: "ellipsis", textStyle: "label/M/regular", children: s }) }),
            d && /* @__PURE__ */ i(h, { noOfLines: 2, textOverflow: "ellipsis", textStyle: "label/S/regular", color: "foreground.secondary", children: d })
          ] })
        ] }),
        /* @__PURE__ */ i(S, { mt: "2px", justifyContent: "flex-end", color: "foreground.primary", children: f })
      ] })
    }
  );
}
const q = {
  file_upload: "document-upload",
  comment: "message-text-1",
  code: "code",
  connector: "data",
  json: "document-code",
  metric: "metrics",
  schema: "schema",
  secret: "key",
  table: "table",
  text: "document-text-1",
  visualization: "visualization",
  fallback: "edit"
}, Q = (n) => q[n] || q.fallback, St = (n) => {
  const { options: t, selectedIndex: e, onSelectItem: o, onMouseEnterItem: c } = n, {
    block: l = [],
    table: d = [],
    connector: s = [],
    external_data: a = [],
    text: u = [],
    json: f = []
  } = Nt(t), m = [...l, ...d, ...s, ...a, ...u, ...f].length;
  return y(() => {
    var r;
    (r = document.getElementById("typeahead-item-" + e)) == null || r.scrollIntoView({ behavior: "instant", block: "nearest" });
  }, [e]), /* @__PURE__ */ g(
    x,
    {
      zIndex: "1000",
      position: "absolute",
      layerStyle: "modal",
      paddingX: "0",
      overflow: "auto",
      maxHeight: "24rem",
      minWidth: {
        base: "100vw",
        md: "264px"
      },
      children: [
        !m && /* @__PURE__ */ i(h, { children: "No results" }),
        !!a.length && /* @__PURE__ */ g(O, { children: [
          /* @__PURE__ */ i(
            h,
            {
              paddingBottom: "spacing-xxs",
              paddingX: "spacing-sm",
              color: "foreground.secondary",
              textStyle: "label/S/medium",
              children: "External Data"
            }
          ),
          /* @__PURE__ */ i(x, { children: a.map((r) => /* @__PURE__ */ i(
            L,
            {
              id: "typeahead-item-" + r.index,
              isSelected: e === r.index,
              onClick: () => o(r, r.index),
              onMouseEnter: () => c(r.index),
              primaryLabel: r.name,
              leftIcon: /* @__PURE__ */ i(_, { name: Q(r.id), size: "sm" }),
              setRefElement: r.setRefElement,
              tabIndex: -1
            },
            r.id
          )) })
        ] }),
        !!l.length && /* @__PURE__ */ g(O, { children: [
          /* @__PURE__ */ i(
            h,
            {
              paddingTop: "spacing-xs",
              paddingBottom: "spacing-xxs",
              paddingX: "spacing-sm",
              color: "foreground.secondary",
              textStyle: "label/S/medium",
              children: "Blocks"
            }
          ),
          /* @__PURE__ */ i(x, { children: l.map((r) => /* @__PURE__ */ i(
            L,
            {
              id: "typeahead-item-" + r.index,
              isSelected: e === r.index,
              onClick: () => o(r, r.index),
              onMouseEnter: () => c(r.index),
              primaryLabel: r.name,
              leftIcon: /* @__PURE__ */ i(_, { name: Q(r.id), size: "sm" }),
              setRefElement: r.setRefElement,
              tabIndex: -1
            },
            r.id
          )) })
        ] }),
        !!d.length && /* @__PURE__ */ g(O, { children: [
          /* @__PURE__ */ i(
            h,
            {
              paddingTop: "spacing-xs",
              paddingBottom: "spacing-xxs",
              paddingX: "spacing-sm",
              color: "foreground.secondary",
              textStyle: "label/S/medium",
              children: "Tables"
            }
          ),
          /* @__PURE__ */ i(x, { children: d.map((r) => /* @__PURE__ */ i(
            L,
            {
              id: "typeahead-item-" + r.index,
              isSelected: e === r.index,
              onClick: () => o(r, r.index),
              onMouseEnter: () => c(r.index),
              primaryLabel: r.name,
              secondaryLabel: r.description,
              leftIcon: /* @__PURE__ */ i(_, { name: r.iconName || "", size: "sm" }),
              setRefElement: r.setRefElement,
              tabIndex: -1
            },
            r.id
          )) })
        ] }),
        !!s.length && /* @__PURE__ */ g(O, { children: [
          /* @__PURE__ */ i(
            h,
            {
              paddingTop: "spacing-xs",
              paddingBottom: "spacing-xxs",
              paddingX: "spacing-sm",
              color: "foreground.secondary",
              textStyle: "label/S/medium",
              children: "Data Sources"
            }
          ),
          /* @__PURE__ */ i(x, { children: s.map((r) => /* @__PURE__ */ i(
            L,
            {
              id: "typeahead-item-" + r.index,
              isSelected: e === r.index,
              onClick: () => o(r, r.index),
              onMouseEnter: () => c(r.index),
              primaryLabel: r.name,
              secondaryLabel: r.description,
              leftIcon: /* @__PURE__ */ i(Je, { connectorType: r.iconName, size: "sm" }),
              setRefElement: r.setRefElement,
              tabIndex: -1
            },
            r.id
          )) })
        ] }),
        !!u.length && /* @__PURE__ */ g(O, { children: [
          /* @__PURE__ */ i(
            h,
            {
              paddingTop: "spacing-xs",
              paddingBottom: "spacing-xxs",
              paddingX: "spacing-sm",
              color: "foreground.secondary",
              textStyle: "label/S/medium",
              children: "Text Sources"
            }
          ),
          /* @__PURE__ */ i(x, { children: u.map((r) => /* @__PURE__ */ i(
            L,
            {
              id: "typeahead-item-" + r.index,
              isSelected: e === r.index,
              onClick: () => o(r, r.index),
              onMouseEnter: () => c(r.index),
              primaryLabel: r.name,
              secondaryLabel: r.description,
              leftIcon: /* @__PURE__ */ i(_, { name: r.iconName || "", size: "sm" }),
              setRefElement: r.setRefElement,
              tabIndex: -1
            },
            r.id
          )) })
        ] }),
        !!f.length && /* @__PURE__ */ g(O, { children: [
          /* @__PURE__ */ i(
            h,
            {
              paddingTop: "spacing-xs",
              paddingBottom: "spacing-xxs",
              paddingX: "spacing-sm",
              color: "foreground.secondary",
              textStyle: "label/S/medium",
              children: "JSON Sources"
            }
          ),
          /* @__PURE__ */ i(x, { children: f.map((r) => /* @__PURE__ */ i(
            L,
            {
              id: "typeahead-item-" + r.index,
              isSelected: e === r.index,
              onClick: () => o(r, r.index),
              onMouseEnter: () => c(r.index),
              primaryLabel: r.name,
              secondaryLabel: r.description,
              leftIcon: /* @__PURE__ */ i(_, { name: r.iconName || "", size: "sm" }),
              setRefElement: r.setRefElement,
              tabIndex: -1
            },
            r.id
          )) })
        ] })
      ]
    }
  );
}, ae = Ae(void 0), _t = (n) => {
  const { placeholders: t, resources: e, children: o, references: c } = n;
  return /* @__PURE__ */ i(ae.Provider, { value: { placeholders: t, resources: e, references: c }, children: o });
}, Rt = () => {
  const n = ke(ae);
  if (!n)
    throw new Error("usePromptEditor must be used within a PromptEditorProvider");
  return n;
}, It = {
  search(n, t, e) {
    const o = n.filter(
      (c) => c.name.replace(" ", "_").toLowerCase().includes(t.toLowerCase())
    );
    e(o);
  }
};
function Ot(n) {
  const [t, e] = P([]), { resources: o, references: c } = Rt();
  return y(() => {
    const l = [
      ...Object.values(Tt).map((d, s) => ({
        id: d.id,
        name: d.name,
        index: s,
        group: d.group,
        key: d.id,
        setRefElement: () => {
        }
      })),
      ...Object.values(o).filter((d) => !c.includes(d.resourceId)).map(
        (d, s) => ({
          id: d.resourceId,
          key: d.resourceId,
          index: s,
          group: d.resourceType,
          name: d.name,
          description: d.description,
          iconName: d.connectorType || We(d),
          setRefElement: () => {
          }
        })
      )
    ];
    if (n == null) {
      e(l);
      return;
    }
    It.search(l, n, e);
  }, [n, o, c]), t;
}
const le = "\\.\\-<>_:", J = ["/"].join(""), de = "[^" + J + le + "\\s]", Lt = "(?:[" + le + "]|)", ue = 75, Mt = new RegExp(
  "(^|\\s|\\()([" + J + "]((?:" + de + Lt + "){0," + ue + "}))$"
), Pt = new RegExp(
  "(^|\\s|\\()([" + J + "]((?:" + de + "){0," + ue + "}))$"
);
function wt(n, t) {
  let e = Mt.exec(n);
  if (e === null && (e = Pt.exec(n)), e !== null) {
    const o = e[1], c = e[3];
    if (c.length >= t)
      return {
        leadOffset: e.index + o.length,
        matchingString: c,
        replaceableString: e[2]
      };
  }
  return null;
}
const Dt = 20;
function At() {
  const [n, t] = P(null), [e] = b(), o = Ot(n), c = F(
    (s, a, u) => {
      e.update(() => {
        a && (s.id === "file_upload" && (e.dispatchCommand(se, {}), a == null || a.remove()), s.id === "comment" && (e.dispatchCommand(ie, {}), a == null || a.remove()), ["table", "connector", "text", "secret", "json"].includes(s.group) && (e.dispatchCommand(ce, {
          resourceId: s.id,
          resourceType: s.group
        }), a == null || a.remove()), u());
      });
    },
    [e, n]
  ), l = F(
    (s) => wt(s, 0),
    [e]
  ), d = ve(() => [...o.slice(0, Dt)], [n, o]);
  return /* @__PURE__ */ i(
    je,
    {
      onQueryChange: t,
      onSelectOption: c,
      triggerFn: l,
      options: d,
      menuRenderFn: (s, { options: a, selectedIndex: u, selectOptionAndCleanUp: f, setHighlightedIndex: m }) => s.current ? ze.createPortal(
        /* @__PURE__ */ i(
          St,
          {
            options: a,
            selectedIndex: u,
            onSelectItem: (r, E) => {
              m(E), f(r);
            },
            onMouseEnterItem: (r) => {
              m(r);
            }
          }
        ),
        s.current
      ) : null
    }
  );
}
const kt = (n) => {
  const { onFileUpload: t } = n, [e] = b();
  return y(() => D(
    e.registerCommand(
      se,
      () => (t == null || t(), !1),
      H
    )
  ), [t]), null;
};
class I extends Re {
  constructor(e, o, c) {
    super(e, c);
    G(this, "__confidence");
    this.__confidence = o;
  }
  static getType() {
    return "metric-highlight";
  }
  static clone(e) {
    return new I(e.__text, e.__confidence, e.__key);
  }
  getConfidence() {
    return this.__confidence;
  }
  createDOM(e) {
    const o = super.createDOM(e);
    return re(o, e.theme.semanticTag), o.setAttribute("data-confidence", String(this.__confidence)), o;
  }
  static importJSON(e) {
    return me(e.text, e.confidence);
  }
  exportJSON() {
    return {
      ...super.exportJSON(),
      confidence: this.__confidence,
      type: this.getType()
    };
  }
  canInsertTextBefore() {
    return !1;
  }
  canInsertTextAfter() {
    return !1;
  }
  isTextEntity() {
    return !0;
  }
}
function me(n = "", t = 0) {
  return Ie(new I(n, t));
}
function Z(n) {
  return n instanceof I;
}
function vt(n) {
  const t = n.anchor, e = n.focus, o = n.anchor.getNode(), c = n.focus.getNode();
  return o === c ? o : n.isBackward() ? V(e) ? o : c : V(t) ? o : c;
}
const Ft = {
  0: "Low confidence",
  1: "Medium confidence",
  2: "High confidence"
}, Bt = {
  0: "background.accent-secondary.red-light",
  1: "background.accent-secondary.yellow-light",
  2: "background.accent-secondary.cyan-light"
}, $t = {
  0: "There is not enough data to calculate this metric",
  1: "The AI might make some assumptions",
  2: "There is enough data to calculate this metric"
};
function Ut(n) {
  const { name: t, match: e, menuRef: o, references: c = [], confidence: l, breakdown: d, onRemoveHighlight: s } = n, a = Ft[l], u = Bt[l];
  return /* @__PURE__ */ g(
    x,
    {
      ref: o,
      style: n.style,
      zIndex: "1000",
      position: "absolute",
      layerStyle: "modal",
      overflow: "auto",
      paddingX: "spacing-md",
      minWidth: {
        md: "24rem"
      },
      maxWidth: {
        md: "24rem"
      },
      children: [
        /* @__PURE__ */ g(R, { justifyContent: "space-between", direction: "row", alignItems: "center", children: [
          /* @__PURE__ */ i(M, { label: t, "aria-label": "Metric Name", children: /* @__PURE__ */ i(h, { noOfLines: 1, textStyle: "label/L/medium", children: t }) }),
          /* @__PURE__ */ i(M, { label: "Discard Metric", "aria-label": "Discard", children: /* @__PURE__ */ i(
            pe,
            {
              onClick: () => s == null ? void 0 : s(e),
              variant: "ghost",
              size: "sm",
              icon: /* @__PURE__ */ i(_, { size: "sm", name: "trash" }),
              "aria-label": "Delete"
            }
          ) })
        ] }),
        /* @__PURE__ */ i(M, { placement: "bottom-start", label: $t[l], "aria-label": "Confidence Description", children: /* @__PURE__ */ g(R, { alignItems: "center", direction: "row", gap: "spacing-xs", children: [
          /* @__PURE__ */ i(x, { borderRadius: "radius-xs", background: u, width: "1rem", height: "1rem" }),
          /* @__PURE__ */ i(h, { color: "foreground.secondary", textStyle: "label/S/medium", children: a })
        ] }) }),
        /* @__PURE__ */ g(R, { my: "spacing-md", children: [
          /* @__PURE__ */ g(R, { direction: "row", gap: "0.5", alignItems: "center", children: [
            /* @__PURE__ */ i(h, { textStyle: "label/M/medium", color: "foreground.secondary", children: "Data" }),
            /* @__PURE__ */ i(
              M,
              {
                placement: "top-start",
                label: "An overview of the data available to calculate this metric",
                "aria-label": "Data Overview",
                children: /* @__PURE__ */ i(S, { children: /* @__PURE__ */ i(_, { name: "more-info", size: "xs", color: "foreground.secondary" }) })
              }
            )
          ] }),
          /* @__PURE__ */ g(R, { direction: "row", flexWrap: "wrap", children: [
            c.map((f) => /* @__PURE__ */ i(Ge, { iconName: "data", name: f.name }, f.sourceId)),
            !c.length && /* @__PURE__ */ i(h, { textStyle: "body/S/medium", children: "No data available" })
          ] })
        ] }),
        /* @__PURE__ */ g(R, { my: "spacing-md", children: [
          /* @__PURE__ */ g(R, { direction: "row", gap: "0.5", alignItems: "center", children: [
            /* @__PURE__ */ i(h, { textStyle: "label/M/medium", color: "foreground.secondary", children: "Description" }),
            /* @__PURE__ */ i(
              M,
              {
                placement: "top-start",
                label: "A breakdown of how the AI plans to calculate this metric",
                "aria-label": "Description",
                children: /* @__PURE__ */ i(S, { children: /* @__PURE__ */ i(_, { name: "more-info", size: "xs", color: "foreground.secondary" }) })
              }
            )
          ] }),
          /* @__PURE__ */ i(h, { textStyle: "body/S/medium", children: d || "-" })
        ] })
      ]
    }
  );
}
const Xt = 40;
function jt(n, t, e) {
  const [o, c] = P(!1), [l] = b(), [d, s] = P({ left: "0", top: "0" }), [a, u] = P(null), f = we.createRef();
  y(() => {
    const r = f.current;
    function E(T) {
      !n.contains(T.target) && !(r != null && r.contains(T.target)) && c(!1);
    }
    return window.addEventListener("click", E), () => {
      window.removeEventListener("click", E);
    };
  }, [n, f]), y(() => {
    function r() {
      c(!1);
    }
    return window.addEventListener("scroll", r, !0), () => {
      window.removeEventListener("scroll", r, !0);
    };
  }, []), y(() => {
    function r() {
      var N;
      const E = ee();
      if (te(E)) {
        const U = vt(E), C = K(U, Z);
        if (!C) {
          c(!1);
          return;
        }
        E.getNodes().filter((X) => !Me(X)).find((X) => {
          const j = K(X, Z);
          return C && !C.is(j) || j && !j.is(C);
        }) ? c(!1) : (u(C.getTextContent()), c(!0));
      }
      const T = window.getSelection(), k = (N = T == null ? void 0 : T.focusNode) == null ? void 0 : N.parentElement;
      if (!k) return;
      const { y: v, right: $, width: w, height: W } = k.getBoundingClientRect();
      s({
        left: `${$ - w}px`,
        top: `${v - W + Xt}px`
      });
    }
    return D(
      l.registerUpdateListener(({ editorState: E }) => {
        E.read(() => {
          r();
        });
      }),
      l.registerCommand(
        Oe,
        () => (r(), !1),
        Le
      )
    );
  }, [l]);
  const m = t.find((r) => r.match === a);
  return o ? He(
    /* @__PURE__ */ i(
      Ut,
      {
        menuRef: f,
        references: (m == null ? void 0 : m.references) || [],
        breakdown: m == null ? void 0 : m.breakdown,
        confidence: (m == null ? void 0 : m.confidence) || 0,
        name: (m == null ? void 0 : m.name) || "",
        match: (m == null ? void 0 : m.match) || "",
        style: { ...d },
        onRemoveHighlight: e
      }
    ),
    window.document.body
  ) : null;
}
function zt({
  anchorElem: n = document.body,
  highlights: t,
  onRemoveHighlight: e
}) {
  return jt(n, t, e);
}
function Ht(n) {
  return n.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function Jt(n) {
  return `(?:${n.map((e) => Ht(e.match)).join("|")})`;
}
function Wt(n) {
  const { highlights: t } = n, [e] = b();
  y(() => {
    e.update(() => {
      function l(a) {
        return (a.getChildren ? a.getChildren() : []).reduce((f, m) => f.concat(m, l(m)), []);
      }
      const d = ne();
      l(d).forEach((a) => {
        a instanceof I && a.replace(Pe(a.getTextContent()));
      });
    });
  }, [e, t]);
  const o = F(
    (l) => {
      var s;
      const d = ((s = t.find((a) => a.match === l.getTextContent())) == null ? void 0 : s.confidence) ?? 0;
      return me(l.getTextContent(), d);
    },
    [t]
  ), c = F(
    (l) => {
      if (!t.length)
        return null;
      const s = new RegExp(Jt(t)).exec(l);
      if (s === null)
        return null;
      const a = s[0].length, u = s.index;
      return {
        end: u + a,
        start: u
      };
    },
    [t]
  );
  return Ve(c, I, o), null;
}
function Gt(n) {
  const { onAddReference: t } = n, [e] = b();
  return y(() => D(
    e.registerCommand(
      ce,
      (o) => {
        const { resourceId: c, resourceType: l } = o;
        return t == null || t(c, l), !1;
      },
      H
    )
    // when we add the @ command -> insert existing reference
  ), [e]), null;
}
function Vt({ isEditable: n }) {
  const [t] = b();
  return y(() => {
    t.setEditable(n);
  }, [n, t]), null;
}
function Kt() {
  const [n] = b();
  return /* @__PURE__ */ i(x, { fontSize: "xs", color: "foreground.secondary", padding: "4", children: /* @__PURE__ */ i(
    Ke,
    {
      treeTypeButtonClassName: "debug-treetype-button",
      timeTravelButtonClassName: "debug-timetravel-button",
      timeTravelPanelButtonClassName: "debug-timetravel-button",
      timeTravelPanelClassName: "debug-timetravel-panel",
      timeTravelPanelSliderClassName: "debug-timetravel-slider",
      viewClassName: "tree-view-output",
      editor: n
    }
  ) });
}
const Yt = {
  comment: "ps_editor__comment",
  textPlaceholder: "ps_editor__text-placeholder",
  filePlaceholder: "ps_editor__file-placeholder",
  semanticTag: "ps_editor__semantic-tag"
}, qt = [A, I, Ee], Qt = (n, t) => {
  const { MenuOptions: e, defaultState: o, debug: c = !1, isEditable: l = !0 } = n, { references: d, resources: s, placeholders: a, highlights: u } = n, { onChange: f, onRemoveHighlight: m, onAddReference: r, onFileUpload: E, onError: T = () => {
  } } = n, k = {
    namespace: "PB_PROMPT_EDITOR",
    nodes: qt,
    editorState: o,
    editable: l,
    onError: T,
    theme: Yt
  }, [v, $] = P(null), w = Be(oe(o));
  return /* @__PURE__ */ i(_t, { placeholders: a, resources: s, references: d, children: /* @__PURE__ */ i(S, { direction: "column", justifyContent: "space-between", width: "100%", position: "relative", children: /* @__PURE__ */ g(xe, { initialConfig: k, children: [
    /* @__PURE__ */ i(be, {}),
    /* @__PURE__ */ i(
      Te,
      {
        contentEditable: /* @__PURE__ */ i(qe, { onRef: (N) => {
          N !== null && $(N);
        } }),
        placeholder: /* @__PURE__ */ g(
          h,
          {
            textStyle: "body/M/regular",
            color: "text.placeholder",
            pointerEvents: "none",
            position: "absolute",
            top: "1rem",
            children: [
              "Type your query here or press ",
              /* @__PURE__ */ i(he, { children: "/" }),
              " to add a reference."
            ]
          }
        ),
        ErrorBoundary: ye
      }
    ),
    /* @__PURE__ */ i(
      Ce,
      {
        ignoreSelectionChange: !0,
        ignoreHistoryMergeTagChange: !1,
        onChange: (N) => {
          N.read(() => {
            const U = ne(), C = Qe(U);
            C !== w.current && (w.current = C, f == null || f(C, N.toJSON()));
          });
        }
      }
    ),
    /* @__PURE__ */ i(Ze, { editorRef: t, previousTextRef: w }),
    /* @__PURE__ */ i(Vt, { isEditable: l }),
    /* @__PURE__ */ i(Gt, { onAddReference: r }),
    /* @__PURE__ */ i(kt, { onFileUpload: E }),
    /* @__PURE__ */ i(At, {}),
    /* @__PURE__ */ i(bt, {}),
    /* @__PURE__ */ i(Wt, { highlights: u }),
    v && /* @__PURE__ */ i(
      zt,
      {
        anchorElem: v,
        highlights: u,
        onRemoveHighlight: m
      }
    ),
    e,
    c ? /* @__PURE__ */ i(Kt, {}) : ""
  ] }) }) });
}, Nn = Fe(Qt);
export {
  Nn as PromptEditor
};
//# sourceMappingURL=index.js.map
